export const dataSidebar = [
  { title: "Name", data: "Skap" },
  { title: "Name", data: "Skap" },
  { title: "Name", data: "Skap" },
  { title: "Name", data: "Skap" },
  { title: "Name", data: "Skap" },
];
